import { useContext, useEffect, useState } from 'react'
import { M_Table, M_MessageBoard, M_Button, LoadingContext, BufferService, NavigateContext } from 'src/M_Components'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'

export const ShipmentList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const [refresh, setRefresh] = useState(false)
    const [selectedRows, setSelectedRows] = useState([])
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false)
    const [shipmentToDelete, setShipmentToDelete] = useState()
    const shipmentService = new BufferService('shipment')
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const { t } = useTranslation()
    const { bookingId } = useParams()

    const [filter, setFilter] = useState()

    useEffect(() => {
        setFilter(bookingId)
    }, [bookingId])

    useEffect(() => {
        if (filter !== undefined) setRefresh(true)
    }, [filter])

    const getCombinedFilter = () => {
        if (filter) return `IdBooking eq ${filter}`
        return undefined
    }

    const navigate = (operation, data) => {
        ctx.passValue?.set('operation', operation)

        if (operation === 'create') {
            ctx2.newTab('go/shipmentDetail', t('CreateShipment'))
            return
        }

        if (!data && selectedRows.length === 0) {
            ctx.toastMessages('error', '', t('SelectedLine'))
            return
        }

        if (operation === 'edit') {
            ctx.passValue.set('Row', data)
            ctx2.newTab('go/shipmentDetail', t('EditShipment'))
        }

        if (operation === 'copy') {
            ctx.passValue.set('Row', data)
            ctx2.newTab('go/shipmentDetail', t('CopyShipment'))
        }
    }

    const deleteShipment = (data) => {
        if (!data) {
            ctx.toastMessages('error', '', t('SelectedLine'))
            return
        }
        const id = Array.isArray(data) ? data[data.length - 1].Id : data.Id
        shipmentService.delete(id).then((resData) => {
            if (resData.name === 'AxiosError') {
                ctx.toastMessages('error', '', t('ErrorDeleting'))
                return
            }
            ctx.toastMessages('success', '', t('SuccessShipmentDeleted'))
            setRefresh(true)
            setOpenDeleteDialog(false)
        })
    }

    return (
        <div className='backgroundForms'>
            <div>
                <M_Table
                    roleName={'shipment'}
                    filtersOnTable
                    entityName={'shipment'}
                    tablesOrder={tablesOrder}
                    pageUrl={'Shipment'}
                    onTablesOrderUpdate={onTablesOrderUpdate}
                    removeContextItems={['View']}
                    refresh={refresh}
                    setRefresh={setRefresh}
                    rolePermissions={roles}
                    FILTER={getCombinedFilter()}
                    replaceFunctions={new Map([
                        ['Delete', (data) => {
                            setShipmentToDelete(data)
                            setOpenDeleteDialog(true)
                        }],
                        ['Create', (data) => navigate('create', data)],
                        ['Edit', (data) => navigate('edit', data)],
                        ['Copy', (data) => navigate('copy', data)],
                    ])}
                    onPassLine={(rows) => setSelectedRows(rows)}
                />
            </div>
            <div className='dividerTables'></div>
            <M_MessageBoard
                warning
                open={openDeleteDialog}
                onClose={() => setOpenDeleteDialog(false)}
                title={`${t('Delete')} ${t('Shipment')}?`}
                body={<span>{t('TitleConfirmDelete')} <b>{t('Shipment')}</b></span>}
                footer={
                    <div style={{ display: 'flex' }}>
                        <M_Button
                            normal
                            hoverEffect
                            label={t('ButtonCancel')}
                            backgroundColor={'var(--color-red)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenDeleteDialog(false)}
                        />
                        <M_Button
                            normal
                            hoverEffect
                            label={t('Delete')}
                            backgroundColor={'var(--color-green)'}
                            labelColor={'var(--color-white)'}
                            onClick={() => deleteShipment(shipmentToDelete)}
                        />
                    </div>
                }
            />
        </div>
    )
}
